import { useMemo } from 'react';

import { twMerge } from 'tailwind-merge';

import { ValueComponentProps } from './Dropdown';
import { DropdownExpandMoreIcon } from './DropdownExpandMoreIcon';

export function DropdownValueDivider({
  placeholder,
  value,
  multiple,
  open,
  isError,
  disabled,
}: ValueComponentProps) {
  const buttonValue = useMemo(() => {
    if (multiple && Array.isArray(value)) {
      return value.map((option) => option.label).join(', ');
    }
    return value?.label || '';
  }, [multiple, value]);

  return (
    <div
      className={twMerge(
        'font-inter cursor-pointer w-full flex gap-4 hover:bg-v2blueGray-100 justify-between rounded-[10px] pl-4 pr-2 py-1.5 text-sm items-center transition-colors',
        open && 'bg-v2blueGray-100',
        isError && 'border border-v2red',
        disabled &&
          'text-v2blueGray-400 cursor-not-allowed bg-transparent hover:bg-transparent border border-v2blueGray-200',
      )}
    >
      <div className="flex-1 min-w-0 text-left">
        <div
          className={twMerge(
            'h-full block truncate text-v2blueGray-800',
            (!buttonValue || disabled) && 'text-v2blueGray-400',
          )}
        >
          {buttonValue || placeholder}
        </div>
      </div>
      <div className="flex gap-1.5 items-center">
        <div className="w-px h-5 bg-v2blueGray-200" />
        <DropdownExpandMoreIcon open={open} />
      </div>
    </div>
  );
}
